import React from 'react'
import '../assets/css/PrivacyPolicy.css'

export default function PrivacyPolicy() {
  return (
    <div className='bg-container'>
      <div className="privacy-container" >
      <h1 className="privacy-title">Privacy Policy</h1>
      <p id='effective-date'><strong>Effective Date:</strong> 25 November 2025</p>

      <h2 className="section-title">1. Introduction</h2>  
       
      <p>
        Welcome to LearnBerry and ColorCobra (collectively, the “Games”).
        These Games are offered by <strong>Windzoon Technologies Pvt Ltd.</strong>
         We respect your privacy and are committed to
        protecting your personal data. This Privacy Policy explains what
        information we collect, how we use it, and your rights.
      </p>

      <h2 className="section-title">2. Games Covered by This Policy</h2>
       
      <ul>
        <li>LearnBerry</li>
        <li>ColorCobra</li>
      </ul>

      <h2 className="section-title">3. Information We Collect</h2>
       

      <h3 className="sub-title">3.1 Automatically Collected Information</h3>
       
      <p>
        We use advertising services provided by Google (including Google AdMob
        and Google Ads), which may collect device identifiers, advertising IDs,
        IP addresses, and non-personally identifiable usage data to deliver
        relevant ads and measure performance.
      </p>

      <h3 className="sub-title">3.2 What We Do Not Collect</h3>
       
      <p>
        We do not knowingly collect personally identifiable information (PII)
        such as your name, email, postal address, or precise GPS location.
      </p>

      <h2 className="section-title">4. How We Use Collected Information</h2>
       
      <ul>
        <li>Show relevant ads</li>
        <li>Analyze gameplay patterns</li>
        <li>Improve our Games</li>
      </ul>
      <p>We do not sell or rent personal information to third parties.</p>

      <h2 className="section-title">5. Third-Party Services & Advertisers</h2>
       
      <p>
        Our Games integrate with Google Ads/AdMob. These advertisers may collect
        data to show personalized or non-personalized ads. You can adjust ad
        preferences in your device settings.
      </p>

      <h2 className="section-title">6. Children’s Privacy</h2>
       
      <p>
        We do not knowingly collect personal information from children under 13
        without parental consent.
      </p>

      <h2 className="section-title">7. Data Security</h2>
       
      <p>
        We take reasonable measures to protect collected data, but no method is
        100% secure.
      </p>

      <h2 className="section-title">8. Your Rights & Choices</h2>
       
      <ul>
        <li>Opt-out of personalized ads</li>
        <li>Reset advertising ID</li>
        <li>Request deletion of data (if identifiable)</li>
      </ul>

      <h2 className="section-title">9. Changes to This Policy</h2>
       
      <p>
        We may update this Privacy Policy occasionally. The latest version will
        reflect the updated “Effective Date.”
      </p>

      <h2 className="section-title">10. Contact Us</h2>
       
      <p style={{margin: 0 }}><strong>Email:</strong><a id='mail-url' href='mailto:info@windzoon.com' target='_blank' rel="noreferrer"> info@windzoon.com</a></p>
      <p><strong>Website:</strong><a id='web-url' href='https://www.windzoon.com/' target='_blank' rel="noreferrer"> www.windzoon.com</a></p>
    </div>
    </div>
  )
}
